import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "production") {
      console.error("Portal render error:", error);
      if (error && error.stack) console.error("Stack trace:", error.stack);
      if (info && info.componentStack) console.error("Component stack:", info.componentStack);
    }
  }
  render() {
    if (this.state.hasError) {
      if (this.props.compact) {
        return (
          <div className="flex flex-col items-center justify-center py-20 text-center" data-testid="error-boundary-compact">
            <h2 className="font-heading font-bold text-xl text-destructive">Une erreur est survenue dans cette section</h2>
            <p className="text-muted-foreground mt-2 text-sm">Réessayez, ou choisissez une autre section dans le menu de gauche.</p>
            <button onClick={() => this.setState({ hasError: false })}
              className="mt-4 rounded-md bg-primary text-primary-foreground px-4 py-2 text-sm font-medium"
              data-testid="error-retry-btn">Réessayer</button>
          </div>
        );
      }
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-background p-8 text-center" data-testid="error-boundary">
          <h2 className="font-heading font-extrabold text-2xl text-destructive">Une erreur est survenue</h2>
          <p className="text-muted-foreground mt-2">Veuillez recharger la page. Si le problème persiste, contactez l'administration.</p>
          <button onClick={() => window.location.reload()}
            className="mt-6 rounded-md bg-primary text-primary-foreground px-5 py-2 text-sm font-medium"
            data-testid="error-reload-btn">Recharger</button>
        </div>
      );
    }
    return this.props.children;
  }
}
